import graphql__c2d5891d267bb26f8bf9 from "./__generated__/PageSectionSidebarFilesList_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import { useSidebarSectionTitle } from "./useSidebarSectionTitle";
import LibraryFile from "../Library/LibraryFile";

const PageSectionSidebarFilesList = props => {
  const pageSection = useFragment(
    PageSectionSidebarFilesList_pageSection,
    props.pageSection
  );

  const { files } = pageSection;
  const { title } = useSidebarSectionTitle({ pageSection });

  return (
    <div className="page-section page-section-sidebar-files-list card box page-section-sidebar-box border-radius-bottom">
      {title}

      <div className="card-body">
        <ul className="pages-list list-unstyled boxes-list">
          {files.map(file => (
            <li key={file.id} className="box box-shadow">
              <LibraryFile file={file} />
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const PageSectionSidebarFilesList_pageSection = graphql__c2d5891d267bb26f8bf9;

export default PageSectionSidebarFilesList;
